import { DatePicker, DatePickerProps } from 'antd';
import { Dayjs } from 'dayjs';
import { useState } from 'react';

const { RangePicker } = DatePicker;

export default function MyRangePicker({
  onChange,
}: {
  onChange: (dates: [Dayjs | null, Dayjs | null] | null) => void;
}) {
  const [dates, setDates] = useState<[Dayjs | null, Dayjs | null] | null>(null);

  const MAX_RANGE = 30;
  const getYearMonth = (date: Dayjs) => date.year() * 12 + date.month();
  const disabledDate: DatePickerProps['disabledDate'] = (current, { from, type }) => {
    if (from) {
      const minDate = from.add(-MAX_RANGE, 'days');
      const maxDate = from.add(MAX_RANGE, 'days');

      switch (type) {
        case 'year':
          return current.year() < minDate.year() || current.year() > maxDate.year();

        case 'month':
          return getYearMonth(current) < getYearMonth(minDate) || getYearMonth(current) > getYearMonth(maxDate);

        default:
          return Math.abs(current.diff(from, 'days')) >= MAX_RANGE;
      }
    }

    return false;
  };

  return (
    <RangePicker
      value={dates}
      onCalendarChange={(vals) => setDates(vals)}
      disabledDate={disabledDate}
      onChange={onChange}
      format='DD/MM/YYYY'
      style={{ width: '100%' }}
      size='large'
    />
  );
}
